/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ChartService as ɵa} from './lib/chart.service';